import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 32026 19477"
    {...props}
  >
    <defs>
      <style>
        {
          ".str0,.str1,.str2{stroke:#2b2a29;stroke-width:915.031}.str1,.str2{stroke-width:348.627}.str1{stroke:#1c1b17}.fil0{fill:none}.fil1{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2757920072928">
        <rect
          width={19570}
          height={14510}
          x={458}
          y={857}
          className="str0 stroke1"
          rx={1283}
          ry={1334}
          style={{
            fill: "transparent",
          }}
        />
        <path
          d="M4280 17755h11925c473 0 860 387 860 860v1c0 3-1 5-5 5H3425c-3 0-5-2-5-5v-1c0-473 387-860 860-860zM7915 16755h4524l959 958v1l-13 13H6970l-13-13v-1z"
          className="str1 stroke1"
          style={{
            strokeWidth: "915.031",
            fill: "transparent",
          }}
        />
        <rect
          width={14663}
          height={8502}
          x={2911}
          y={3157}
          className="str0 stroke1"
          rx={984}
          ry={801}
          style={{
            strokeWidth: "915.031",
            fill: "transparent",
          }}
        />
        <rect
          width={9083}
          height={18562}
          x={22486}
          y={458}
          className="str0 stroke1"
          rx={1434}
          ry={1351}
          style={{
            strokeWidth: "915.031",
            fill: "transparent",
          }}
        />
        <rect
          width={6218}
          height={1219}
          x={23919}
          y={7969}
          className="str2 stroke1"
          rx={8611}
          ry={778}
          style={{
            strokeWidth: "915.031",
            fill: "transparent",
          }}
        />
        <rect
          width={6218}
          height={1219}
          x={23919}
          y={5264}
          className="str2 stroke1"
          rx={8611}
          ry={778}
          style={{
            strokeWidth: "915.031",
            fill: "transparent",
          }}
        />
        <rect
          width={6218}
          height={1219}
          x={23919}
          y={2689}
          className="str2 stroke1"
          rx={8611}
          ry={778}
          style={{
            strokeWidth: "915.031",
            fill: "transparent",
          }}
        />
        <path
          d="M25273 10965h3509v586h-3509z"
          className="str2 stroke1"
          style={{
            strokeWidth: "915.031",
            fill: "transparent",
          }}
        />
        <circle
          cx={27028}
          cy={15008}
          r={950}
          className="str2 stroke1"
          style={{
            strokeWidth: "915.031",
            fill: "transparent",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
